export const LOGO_FACETS = "M77.31 18.08 L92.71 27.98 L90.42 75.98 L74.38 65.67 L75.76 36.72 L63.76 29.01Z M9.58 24.02 L25.62 34.33 L24.24 63.28 L34.07 69.59 L23.58 82.49 L7.29 72.02Z";
export const LOGO_MAIN = "M9.58 24.02 L52.29 2.0 L77.31 18.08 L63.76 29.01 L51.38 21.06 L25.62 34.33Z M23.58 82.49 L47.71 98.0 L64.67 89.26 L34.07 69.59Z M50.09 50.27 L90.42 76.19 L73.28 84.82 L30.63 57.41Z";

export default function LogoMark({ size = 34, className = "", title }) {
  return (
    <svg width={size} height={size} viewBox="0 0 100 100" className={className} role={title ? "img" : undefined} aria-label={title} aria-hidden={title ? undefined : true} data-testid="logo-mark">
      <path d={LOGO_FACETS} fill="#A8853F" stroke="#A8853F" strokeWidth="1" strokeLinejoin="round" />
      <path d={LOGO_MAIN} fill="#D6B36A" stroke="#D6B36A" strokeWidth="1" strokeLinejoin="round" />
    </svg>
  );
}
